import {useEffect, useState} from 'react';
import * as qs from "query-string";
import { OauthAPIInstance} from '../../api/app-api';

export function useAdsInfoAPI () {
    const [adsInfo, setAdsInfo] = useState({})

    const getAds = async (bindingID) => {
        const resp = await OauthAPIInstance.getAds(bindingID);
        if (resp.status === 200) {
            return await resp.json();
        }

        return {}
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect( () => {
        const fetchBinding = async () => {
            let params = qs.parse(window.location.href.split('?')[1]);
            if (Object.entries(params).length !== 0 && params.constructor !== Object) {
                let binding_token = params.binding_token;
                if (binding_token) {
                    let adsInfo =  await getAds(binding_token);
                    setAdsInfo(adsInfo);
                }
            } else {
                throw "error: params is null"
            }
        }
        fetchBinding().catch(console.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return adsInfo;
}
